module.exports = __webpack_public_path__ + "static/media/profile_os.c2159146.jpg";